import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Api's
import { modelApi } from "@/main/api";

// Redux
import { saveModels, GetModels } from "./index";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";
import { VehicleFiltersRequest } from "@/main/models/request";

export function* getModelsSaga(action: GetModels) {
	const requestAdapter: VehicleFiltersRequest = {
		guidVehicleManufacturer: action.payload.request.guidManufacturer,
		guidVehicleModel: action.payload.request.guidModel,
		guidVehicleSubModel: action.payload.request.guidSubModel,
		guidVehicleYear: action.payload.request.guidYear,
		guidCountry: action.payload.request.guidCountry,
	};

	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(modelApi.getVehicleModelByFilters, requestAdapter);
		if (response.data.result) {
			yield put(saveModels(response.data.result, false, null, action.payload.keyReducer));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveModels(null, true, resultError.messagesDataError, action.payload.keyReducer));
		}
	}
}
